import { render, staticRenderFns } from "./Zakat.vue?vue&type=template&id=b4ca895a"
import script from "./Zakat.vue?vue&type=script&lang=js"
export * from "./Zakat.vue?vue&type=script&lang=js"
import style0 from "./Zakat.vue?vue&type=style&index=0&id=b4ca895a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports